// ============================
// story-scroll.js
// フェードイン：SP 実機対策版（ユーザー操作後にだけ発火）
// ============================
(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStoryEffects);
  } else {
    initStoryEffects();
  }

  function initStoryEffects() {
    initScrollReveal();
    // sticky の固定は CSS 任せ
  }

  function initScrollReveal() {
    var items = document.querySelectorAll(".story-reveal");
    if (!items.length) return;

    var groups = {};
    var indexCounter = 0;

    // 1) 初期化：visible クラスを全部外しつつ、グルーピング
    Array.prototype.forEach.call(items, function (el) {
      el.classList.remove("is-visible-image");
      el.classList.remove("is-visible-text");

      var groupId =
        el.getAttribute("data-story-reveal-group") ||
        "single-" + indexCounter++;
      if (!groups[groupId]) groups[groupId] = [];
      groups[groupId].push(el);
    });

    var groupIds = Object.keys(groups);
    if (!groupIds.length) return;

    var groupTriggered = {};
    var ticking = false;
    var watchingScroll = false;

    // 2) 最初のグループだけは初期表示（TOP バナー想定）
    var firstGroupId = groupIds[0];
    groupTriggered[firstGroupId] = true;
    revealGroup(groups[firstGroupId]);

    // ----------------------------
    // スクロール監視の開始（ユーザー操作をトリガーに）
    // ----------------------------
    function startWatchingScroll() {
      if (watchingScroll) return;
      watchingScroll = true;

      window.addEventListener("scroll", requestCheck, { passive: true });
      window.addEventListener("resize", requestCheck);

      // すでに少しスクロールしている位置から開いた場合にも対応
      requestCheck();
    }

    // 最初のユーザー操作を検知したらスクロール監視を開始
    function onFirstUserInteraction() {
      startWatchingScroll();

      // もう要らないので外す
      window.removeEventListener("touchstart", onFirstUserInteraction);
      window.removeEventListener("touchmove", onFirstUserInteraction);
      window.removeEventListener("wheel", onFirstUserInteraction);
      window.removeEventListener("keydown", onFirstUserInteraction);
    }

    window.addEventListener("touchstart", onFirstUserInteraction, {
      passive: true,
    });
    window.addEventListener("touchmove", onFirstUserInteraction, {
      passive: true,
    });
    window.addEventListener("wheel", onFirstUserInteraction, { passive: true });
    window.addEventListener("keydown", onFirstUserInteraction);

    // ----------------------------
    // スクロール / リサイズ時にグループをチェック
    // ----------------------------
    function requestCheck() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        checkGroups();
        ticking = false;
      });
    }

    function checkGroups() {
      var winH =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        0;

      // 画面下から 20% 手前で発火
      var triggerLine = winH * 0.95;

      groupIds.forEach(function (groupId) {
        if (groupTriggered[groupId]) return;

        var els = groups[groupId];
        if (!els || !els.length) return;

        var baseEl = els[0]; // グループ内の先頭要素を代表にする
        var rect = baseEl.getBoundingClientRect();

        // すでに上に消えている / まだかなり下にある場合はスキップ
        if (rect.bottom <= 0) return;
        if (rect.top >= winH) return;

        // 要素のやや上寄りの位置（40%）を基準にする
        var refPoint = rect.top + rect.height * 0.2;

        if (refPoint < triggerLine) {
          groupTriggered[groupId] = true;
          revealGroup(els);
        }
      });
    }
  }

  // グループ内の要素を順番にフェードイン
  function revealGroup(els) {
    els.forEach(function (el, i) {
      setTimeout(function () {
        revealElement(el);
      }, 0 + i * 500); // グループ内ディレイ
    });
  }

  function revealElement(el) {
    if (el.classList.contains("story-reveal--image")) {
      el.classList.add("is-visible-image");
    } else if (el.classList.contains("story-reveal--text")) {
      el.classList.add("is-visible-text");
    } else {
      // 保険
      el.classList.add("is-visible-text");
    }
  }
})();
